import { Col, Form, Row } from "antd";
import React, { useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import { convertFileToBase64 } from "../../../../components/utils/utils";

interface HousingInfoProps {
  housingTypes: any;
  housingStates: any;
  housingOwnerships: any;
  form: any;
}

const HousingInfo = ({
  housingTypes,
  housingStates,
  housingOwnerships,
  form,
}: HousingInfoProps) => {
  const [needRentAmount, setNeedRentAmount] = useState(false);

  const handleHousingOwnershipChange = (value: any) => {
    const statusArray = housingOwnerships.data || housingOwnerships;

    const selectedStatus = statusArray.find(
      (status: any) => status.id === value.value
    );

    if (selectedStatus) {
      setNeedRentAmount(selectedStatus.need_rent_amount);
    }
  };
  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          electronic_contract_attachment_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>سكن الأسرة</span>
      </div>
      <Row gutter={16}>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="housing_type_id"
            label="نوع السكن"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={housingTypes?.data} />
          </Form.Item>
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="housing_ownership_id"
            label="ملكية السكن"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              onChange={handleHousingOwnershipChange}
              options={housingOwnerships?.data}
            />
          </Form.Item>
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="housing_state_id"
            label="حالة السكن"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={housingStates?.data} />
          </Form.Item>
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="rooms_number"
            label="عدد الغرف"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="tel" />
          </Form.Item>
        </Col>
        {needRentAmount && (
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="rent_amount"
              label="مقدار الإيجار السنوي"
              rules={[
                {
                  required: needRentAmount,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs disabled={!needRentAmount} type="tel" />
            </Form.Item>
          </Col>
        )}

        {needRentAmount && (
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="electronic_contract_attachment_ids"
              label="عقد الإيجار الالكتروني"
              rules={[
                {
                  required: needRentAmount,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <UploadInput
                accept="*"
                text="عقد الإيجار الالكتروني"
                icon={<UploadOutlined />}
                multiple={false}
                maxCount={1}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );
};

export default HousingInfo;
